<div class="tw-w-full tw-flex tw-flex-col balance-hud">
  <!-- Header Section -->
  <div
    class="tw-flex tw-w-full tw-px-6 tw-py-4 tw-items-center tw-justify-between tw-bg-dt-surface-card"
  >
    <div
      class="tw-text-lg tw-font-semibold tw-uppercase sm:tw-text-sm"
      data-testid="scenario-hud-period"
    >
      <span class="tw-text-dt-text-future-primary">{{ periodCount() }}</span>
      <span class="tw-text-dt-text-secondary">
        {{ periodUnit() }} {{ "scenarioPeriodAhead" | i18n }}</span
      >
    </div>
    <div class="tw-flex tw-gap-4">
      <div class="tw-flex tw-flex-col tw-text-end tw-text-base">
        <span class="tw-font-medium tw-text-dt-text-future-primary tw-whitespace-nowrap">{{
          balanceDate() | date: "MMM yyyy"
        }}</span>
        <span class="tw-text-dt-text-tertiary">({{ currency() }})</span>
      </div>
      <button
        class="tw-rounded-xl tw-flex tw-justify-center tw-items-center tw-bg-color-surface-card tw-p-2 tw-h-[40px] tw-aspect-square tw-cursor-pointer tw-shadow-elevation-card border-gradient-neuomorphic border-active-future"
        (click)="handleExpand($event)"
      >
        <icon [name]="helperExpand.icon" [size]="6" [currentColor]="'color-text-secondary'"></icon>
      </button>
    </div>
  </div>

  <!-- Scenario HUD Card -->
  <div class="tw-bg-dt-surface-elevated tw-rounded-t-3xl">
    <div
      class="tw-w-full tw-flex tw-flex-col tw-p-4 tw-gap-3 tw-shadow-neuomorphic-elevated border-gradient-neuomorphic border-active-future tw-rounded-3xl tw-bg-dt-surface-elevated"
    >
      <!-- hud-paths--stacked: some balance row can't fit name and amount side by side, so every
           row stacks (measured in the component, see balanceRowsFitSideBySide) -->
      <div
        #pathList
        class="tw-flex tw-flex-col tw-gap-2"
        [class.hud-paths--stacked]="stackBalanceRows()"
      >
        @for (pathBalance of pathBalances(); track idx; let idx = $index) {
          <ng-container
            *ngTemplateOutlet="
              path;
              context: {
                pathName: 'scenarioPathName' | i18n: idx + 1,
                index: idx,
                pathBalance: pathBalance,
              }
            "
          ></ng-container>
        }
      </div>
    </div>
  </div>
</div>

<ng-template
  #accountBalance
  let-account="account"
  let-balance="balance"
  let-nowrapName="nowrapName"
>
  <!-- hud-balance-row: side by side - a long account name wraps between its words, beside the
       amount (a path name, nowrapName, never does) - or, when some row's amount doesn't fit beside
       its name (an account name's longest word), every row at once puts the amount on its own
       right-aligned line (ml-auto). The component measures the name and amount spans in that
       order. nowrap keeps a negative amount from breaking after its sign. On phones the amount is
       14px, so even 13 integer digits fit its own line at the app's 344px minimum width. A single
       word too long for the row breaks anywhere (an arbitrary property: Tailwind doesn't prefix
       those) rather than spilling out of the card. -->
  <div
    class="hud-balance-row tw-w-full tw-flex tw-items-baseline tw-justify-between tw-gap-x-2 tw-px-6 tw-py-3 xs:tw-px-3"
  >
    <span class="tw-min-w-0 [overflow-wrap:anywhere]" [class.tw-whitespace-nowrap]="nowrapName">{{
      account
    }}</span>
    <span
      class="tw-ml-auto tw-shrink-0 tw-font-medium tw-whitespace-nowrap xs:tw-text-sm"
      [class.tw-text-dt-text-in-primary]="balance > 0.01"
      [class.tw-text-dt-text-secondary]="balance >= -0.01 && balance <= 0.01"
      [class.tw-text-dt-text-out-primary]="balance < -0.01"
      >{{ balance | currency }}</span
    >
  </div>
</ng-template>

<ng-template #path let-pathName="pathName" let-pathBalance="pathBalance" let-index="index">
  <div
    class="tw-flex tw-flex-col tw-bg-color-surface-card tw-shadow-elevation-card border-gradient-path-tabs tw-rounded-xl"
  >
    <div class="tw-overflow-hidden tw-rounded-xl">
      <div class="tw-flex tw-items-center tw-px-4 tw-py-3 glass-path-header">
        <app-radio-button
          [style]="'hud'"
          [isSelected]="selectedPathIndex() === index"
          (click)="handleRadioButtonClick($event, index)"
          [attr.data-testid]="'scenario-hud-radio-path-' + (index + 1)"
        ></app-radio-button>
        <!-- min-w-0 / shrink-0: a fallback if a row ever outgrows the HUD even stacked (e.g. a long
             translated path name), so it shrinks rather than pushing the chevron out. -->
        <div class="tw-flex tw-w-full tw-min-w-0" (click)="handleCollapse($event, index)">
          <div class="tw-w-full tw-min-w-0 tw-font-medium">
            <ng-container
              *ngTemplateOutlet="
                accountBalance;
                context: { account: pathName, balance: pathBalance, nowrapName: true }
              "
            ></ng-container>
          </div>
          <icon class="tw-shrink-0" [name]="helperCollapse[index].icon" [size]="5"></icon>
        </div>
      </div>
      @if (!helperCollapse[index].isCollapsed) {
        <div
          class="glass-dropdown-panel glass-dropdown-panel-future"
          [attr.data-testid]="'scenario-hud-expanded-path-' + (index + 1)"
        >
          @for (account of pathBalanceAccounts()[index]; track account.accountID) {
            <ng-container *ngTemplateOutlet="accountBalance; context: account"></ng-container>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
